// The README badge one-liner (arc 101 slice 11, plan doc 06) — ONE builder now
// that two surfaces hand it over: the maintainer inbox's empty state, which has
// no project in hand and so passes the placeholder, and a repo's own "accept
// donations" panel, which knows its full name and fills it in.
//
// Pure string work, deliberately not a component: what the snippet SAYS is a
// contract with `apps/marketing` — `/badge/donate/:owner/:repo.svg` renders the
// pill (falling back to a static one for a repo nobody may fund, so it is never
// a broken image in someone's README) and the link lands on the PUBLIC project
// page, never straight at checkout. A contract is worth testing without a DOM.

/** Marketing origin, hardcoded like every other www link in the SPA (`lib/publicOss.ts`). */
const SITE = 'https://www.developerz.ai';

/**
 * What stands in for `owner/repo` where no single project applies — the
 * account-wide inbox. Named verbatim in the copy that tells a maintainer to swap
 * it, so the two can't drift.
 */
export const DONATE_BADGE_PLACEHOLDER = 'OWNER/REPO';

/** The markdown line a maintainer pastes: the donate badge, linked to its public page. */
export const donateBadgeSnippet = (slug: string): string =>
  `[![Donate a developerz](${SITE}/badge/donate/${slug}.svg)](${SITE}/oss/${slug})`;
